import React from 'react';
import styles from './ChallengeStatusBadge.module.scss';
import { EChallengeStatus } from '../../../types/EChallangeStatus';

type Variant = 'live' | 'open' | 'waiting' | 'done' | 'danger' | 'critical' | 'neutral';

const VARIANT_CLASS: Record<Variant, string> = {
    live: styles.live,
    open: styles.open,
    waiting: styles.waiting,
    done: styles.done,
    danger: styles.danger,
    critical: styles.critical,
    neutral: styles.neutral,
};

const STATUS_VARIANT: Record<string, Variant> = {
    // active / live flow — green
    [EChallengeStatus.IN_PROGRESS]: 'live',
    [EChallengeStatus.READY_TO_START]: 'live',
    [EChallengeStatus.CREATING_LOBBY]: 'live',
    [EChallengeStatus.FAIR_PLAY]: 'live',
    // open / waiting for opponent — blue
    [EChallengeStatus.PUBLISHED]: 'open',
    // not yet active — neutral
    [EChallengeStatus.DRAFT]: 'neutral',
    // terminal / completed — purple
    [EChallengeStatus.FINISHED]: 'done',
    // problematic — needs admin attention — red
    [EChallengeStatus.CANCELED]: 'danger',
    [EChallengeStatus.EXPIRED]: 'danger',
    [EChallengeStatus.UNKNOWN]: 'danger',
    // requires immediate manual action — solid red, stands out
    [EChallengeStatus.SUSPICIOUS]: 'critical',
};

// "StreamNotFound" -> "Stream Not Found"
const formatLabel = (status: string): string => status.replace(/([a-z0-9])([A-Z])/g, '$1 $2');

interface IChallengeStatusBadgeProps {
    status?: string | null;
}

export const ChallengeStatusBadge = ({ status }: IChallengeStatusBadgeProps): React.JSX.Element => {
    if (!status) {
        return <span className={`${styles.badge} ${VARIANT_CLASS.neutral}`}>—</span>;
    }

    const variant = STATUS_VARIANT[status] ?? 'neutral';

    return <span className={`${styles.badge} ${VARIANT_CLASS[variant]}`}>{formatLabel(status)}</span>;
};
